/**
 * List of EU country codes (ISO 3166-1 alpha-2)
 * As of 2025, the EU consists of 27 member states
 */
export const EU_COUNTRY_CODES = [
  'AT', // Austria
  'BE', // Belgium
  'BG', // Bulgaria
  'HR', // Croatia
  'CY', // Cyprus
  'CZ', // Czech Republic
  'DK', // Denmark
  'EE', // Estonia
  'FI', // Finland
  'FR', // France
  'DE', // Germany
  'GR', // Greece
  'HU', // Hungary
  'IE', // Ireland
  'IT', // Italy
  'LV', // Latvia
  'LT', // Lithuania
  'LU', // Luxembourg
  'MT', // Malta
  'NL', // Netherlands
  'PL', // Poland
  'PT', // Portugal
  'RO', // Romania
  'SK', // Slovakia
  'SI', // Slovenia
  'ES', // Spain
  'SE', // Sweden
]

/**
 * Check if a country code belongs to an EU member state
 * @param countryCode - ISO 3166-1 alpha-2 country code
 * @returns true if the country is in the EU
 */
export const isEUCountry = (countryCode: string | null | undefined): boolean => {
  if (!countryCode) return false
  return EU_COUNTRY_CODES.includes(countryCode.toUpperCase())
}
